<template>
	<div class="clearfix">
        <template v-show="data != null && viewPage == true">
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left mt-2"> Campuses/Branches </h1>
                <router-link to="/feeAddCampus" class="btn btn-primary float-right active"> + Add New </router-link>
            </div>
            <div class="row normal-ib-space collections-filters mb-5">
                <div class="col-md-5">
                    <input type="text" class="form-control search" name="" placeholder="Search branches by name" v-model="searchName" @change="getData()" />
                </div>
                <div class="col-md-3">
                    <select class="selectpicker custom-select2" v-model="searchCity" @change="getData()">
                        <option value=""> Select City </option>
                        <template v-if="cities != null">
                           <option v-for="city in cities" :key="city.id" :value="city.id">{{city.name}}</option>
                        </template>
                    </select>
                </div>
                <div class="col-md-4 text-right pt-2 radio-main-holder">
                    <span class="title"> Type: </span>
                    <label class="radio-holder">
                        Both
                        <input v-model="searchType" type="radio" name="type" value="" checked="true" @change="getData()">
                        <span class="checkmark"></span>
                    </label>
                    <label class="radio-holder">
                        Franchise
                        <input v-model="searchType" type="radio" name="type" value="FRANCHISE" @change="getData()">
                        <span class="checkmark"></span>
                    </label>
                    <label class="radio-holder">
                        Owned
                        <input v-model="searchType" type="radio" name="type" value="OWNED" @change="getData()">
                        <span class="checkmark"></span>
                    </label>
                </div>
            </div>
            <div class="collections-dashboard">
                <div class="row" v-if="data != null">
                    <div class="col-md-4" v-for="record in data" :key="record.id">
                        <div class="collection-card text-center clearfix">
                            <h2> {{record.name}} </h2>
                            <span class="branch-code mb-4"> Branch Code: {{record.campus_code}} </span>
                            <span class="number"> {{record.students}} </span>
                            <span class="mb-3"> Student </span>
                            <router-link class="btn btn-primary view-detail-btn" :to="`/feeEditCampus/${record.id}`"> View Detail </router-link>
                            <div class="bottom-btns">
                                <div class="row normal-ib-space">
                                    <div class="col-6"> <button class="btn btn-primary"> {{record.campus_type}} </button> </div>
                                    <div class="col-6"> <button class="btn btn-primary colored-btn"> {{record.status}} </button> </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-if="data == null || viewPage == null"><preLoader></preLoader></template>
        <template v-if="viewPage == false"><notAllowed></notAllowed></template>
	</div>
</template>

<script>
    export default {
        data() {
            return {
                data : null,
                viewPage : null,
                searchName : null,
                searchCity : null,
                searchType : null,
                cities : null,
            };
        },
        mounted() {
            this.$Progress.start();
            this.can('collection').then(result => {
                this.viewPage = result.collection;
                this.getData();
            }).then(result => {
                this.$Progress.finish();
            });
        },
        methods: {
            getData(){
                axios.post('api/listFeeCampus',{name: this.searchName, city: this.searchCity, type: this.searchType})
                .then(result => {
                    this.data = result.data.records;
                    this.cities = result.data.cities;
                }).then(result => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                });

            }
        },
        created() {
            //
        }
    }
</script>
